import React, { Component } from 'react'
import PropertyReport from 'components/PropertyReport'
import "./PropertyReportPage.scss"

class PropertyReportPage extends Component {
  state = {
    tab: 'property-reports'
  }

  render() {
    return (
      <div className="PropertyReportPage">
        <PropertyListingTab tab={this.state.tab} onSelectTab={(tab) => this.setState({ tab: tab })} />
        <PropertyReport />
      </div>
    )
  }
}

export function PropertyListingTab({ tab, onSelectTab = () => {} }) {
  return (
    <div className="PropertyPageHeader">
      <div className="breadcrumb">
        <div className={`menu-item ${tab === "all" ? "active" : ""}`} onClick={() => onSelectTab("property-reports")}>
          <span className="connector"> </span>
          Property Report
        </div>
      </div>
    </div>
  )
}

export default PropertyReportPage
